import { render, staticRenderFns } from "./modifyphone.vue?vue&type=template&id=e94805b0&scoped=true"
import script from "./modifyphone.vue?vue&type=script&lang=js"
export * from "./modifyphone.vue?vue&type=script&lang=js"
import style0 from "./modifyphone.vue?vue&type=style&index=0&id=e94805b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94805b0",
  null
  
)

export default component.exports